import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/Button';

export function Hero() {
  return (
    <section className="relative flex min-h-[90vh] items-center overflow-hidden bg-primary pt-20">
      {/* Background grid pattern */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            'linear-gradient(hsl(160 60% 42%) 1px, transparent 1px), linear-gradient(90deg, hsl(160 60% 42%) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />

      <div className="relative mx-auto max-w-6xl px-6 py-20">
        <div className="max-w-3xl">
          <div className="mb-6 inline-flex items-center rounded-full border border-accent/30 bg-accent/10 px-4 py-1.5">
            <span className="text-xs font-medium tracking-wide text-accent">
              Transformação Digital
            </span>
          </div>

          <h1 className="font-heading text-4xl font-bold leading-tight tracking-tight text-primary-foreground sm:text-5xl lg:text-6xl text-balance">
            No limiar entre o problema e a{' '}
            <span className="text-accent">solução digital.</span>
          </h1>

          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-primary-foreground/70">
            Criamos soluções digitais sob medida para transformar processos,
            integrar sistemas e impulsionar negócios.
          </p>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row">
            <Button
              size="lg"
              asChild
              className="bg-accent text-accent-foreground hover:bg-accent/90"
            >
              <a href="#contato">
                Fale com a Limiar
                <ArrowRight className="ml-2 h-4 w-4" />
              </a>
            </Button>
            <Button
              size="lg"
              variant="outline"
              asChild
              className="border-primary-foreground/20 text-primary-foreground hover:bg-primary-foreground/10 bg-transparent"
            >
              <a href="#servicos">Nossos serviços</a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
